import { useDispatch, useSelector } from 'react-redux';
import KerdesTableService from 'app/admin/kerdes/service/KerdesTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import TableQuestionViewButton from 'app/admin/kerdes/component/TableQuestionViewButton';
import KerdesService from '../service/KerdesService';

const config = {
	key: 'kerdesTable',
	text: 'Kérdés',
	textKey: 'question',
	service: KerdesTableService,
	editFormState: item => {
		if (item) {
			if (item.feladatTipusId === 4) return `/relacioanaliziseskerdes/edit/${item ? item.id : 'new'}`;
			if (item.feladatTipusId === 3) return `/asszociacioskerdes/edit/${item ? item.id : 'new'}`;
			if (item.feladatTipusId === 2) return `/tobbszoroskerdes/edit/${item ? item.id : 'new'}`;
		}
		return `/egyszerukerdes/edit/${item ? item.id : 'new'}`;
	},
	toolbarAction: ['filter', 'refresh'],
	toolbarActionList: [
		{
			text: 'Új egyszerű kérdés',
			icon: 'add',
			link: () => '/egyszerukerdes/edit/new'
		},
		{
			text: 'Új Többszörös kérdés',
			icon: 'add',
			link: () => '/tobbszoroskerdes/edit/new'
		},
		{
			text: 'Új Relációanalízises kérdés',
			icon: 'add',
			link: () => '/relacioanaliziseskerdes/edit/new'
		}
	],
	// rowEndAction: ['subPage', 'modify'],
	// rowClick: item => `/valasz/${item.id}`,
	// subPage: {
	// 	state: '/valasz/',
	// 	tooltip: 'Tartalom'
	// },
	filterFields: [
		{
			text: 'Sorszám',
			propertyName: 'csorszam',
			propertyType: 'String',
			type: 'LIKE'
		},
		{
			text: 'Feladattípus',
			propertyName: 'feladatTipusId',
			propertyType: 'Long',
			type: 'IN'
		},
		{
			text: 'Feladatcsoport',
			propertyName: 'feladatCsoport',
			propertyType: 'Long',
			type: 'IN'
		},
		{
			text: 'Fejezet',
			propertyName: 'fejezet',
			propertyType: 'Long',
			type: 'IN'
		}
	],
	rowButtonList: [
		{
			key: 'questionView',
			component: TableQuestionViewButton,
			service: KerdesService
		}
	],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'csorszam',
			text: 'Sorszám',
			textKey: 'csorszam',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'aktiv',
			text: 'Aktív',
			textKey: 'aktiv',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'reviewCount',
			text: 'Vélemény',
			textKey: 'reviewCount',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'leirasPlaintext',
			text: 'Leírás',
			textKey: 'leirasPlaintext',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		// {
		// 	key: 'magyarazatPlaintext',
		// 	text: 'Magyarázat',
		// 	textKey: 'magyarazatPlaintext',
		// 	type: 'text',
		// 	sortable: true,
		// 	disablePadding: false
		// }
	]
};

function KerdesTable() {
	const user = useSelector(({ auth }) => auth.user);

	const roles = Array.isArray(user?.role) ? user.role : (user?.role ? user.role.split(',').map(r => r.trim()) : []);

	const isOnlyReviewer = roles.length === 1 && roles[0] === 'Reviewer';

	const finalConfig = {
		...config,
		toolbarAction: isOnlyReviewer ? ['refresh'] : config.toolbarAction,
		toolbarActionList: isOnlyReviewer ? [] : config.toolbarActionList,
		rowAction: isOnlyReviewer ? [] : config.rowAction
	};

	return <TableBrowser config={finalConfig} />;
}

export default withReducer('kerdesTable', reducer('kerdesTable'))(KerdesTable);